import { Dropdown } from 'components/common'
import { memo, useEffect, useState } from 'react'
import { fetchAggregators } from 'utils/api/aggregatorApi'

type Props = {
  setValue: any
  label: string
  name: string
  error?: string
  required?: boolean
  defaultValue?: string
  isActive?: boolean
  withNoneOption?: boolean
}

const AggregatorDropdown = ({
  setValue,
  error,
  label,
  name,
  required = false,
  defaultValue,
  isActive,
  withNoneOption = false,
}: Props) => {
  const [options, setOptions] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)

  const getAggregators = async () => {
    try {
      const { data } = await fetchAggregators({
        limit: 500,
        page: 1,
        isActive,
      })

      const aggregators = data?.docs?.map((agg: any) => ({
        label: agg.aggregatorName,
        value: agg._id,
        disabled: false,
      }))

      if (!aggregators || aggregators.length <= 0) {
        return setOptions([])
      }

      if (withNoneOption === true) {
        aggregators.unshift({
          label: '--NONE--',
          value: '',
          disabled: false,
        })
      }

      setOptions(aggregators)
    } catch (err) {
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAggregators()
  }, [])

  if (loading) {
    return <></>
  }

  return (
    <Dropdown
      required={required}
      label={label}
      name={name}
      setValue={setValue}
      error={error}
      defaultValue={defaultValue}
      options={
        options.length <= 0
          ? [
              {
                label: 'No Aggregators Found',
                value: 'NO_AGGREGATOR',
                disabled: true,
              },
            ]
          : options
      }
    />
  )
}

export default memo(AggregatorDropdown)
